var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-container"},[_c('FilledLogo',{staticClass:"text-primary-default bambee-logo"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }